import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';

export const personnelApi = createApi({
  reducerPath: 'Personnel',
  tagTypes: ['Personnel'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getPersonnelData: builder.mutation({
      query: ({
        page,
        size,
        body = {},
        params = { sortBy: 'expirationDate', sortDir: 'desc' },
      }) => ({
        url: `/v1/personnel/personnel?page=${page}&size=${size}`,
        method: 'POST',
        body,
        params,
      }),
    }),
    createOrUpdatePersonnelData: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/personnel/personnel/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
    getPersonnelIdentificationTableData: builder.query({
      query: ({ id, sortBy = 'id', sortDir = 'asc' }) => ({
        url: `/v1/personnel/identification/personnel/${id}?&sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    getPersonnelIdentificationById: builder.query({
      query: ({ id }) => ({
        url: `/v1/personnel/identification/${id}`,
      }),
    }),
    createOrUpdatePersonnelIdentification: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/personnel/identification/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
    getPersonnelCertificationTableData: builder.query({
      query: ({ id, sortBy = 'id', sortDir = 'asc' }) => ({
        url: `/v1/personnel/certifications/personnel/${id}?&sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    getPersonnelCertificationById: builder.query({
      query: ({ id }) => ({
        url: `/v1/personnel/certifications/${id}`,
      }),
    }),
    createOrUpdatePersonnelCertification: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/personnel/certifications/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
    getPersonnelScreeningTableData: builder.query({
      query: ({ id, sortBy = 'id', sortDir = 'desc' }) => ({
        url: `/v1/personnel/screenings/personnel/${id}?&sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    getPersonnelScreeningById: builder.query({
      query: ({ id }) => ({
        url: `/v1/personnel/screenings/${id}`,
      }),
    }),
    createOrUpdatePersonnelScreening: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/personnel/screenings/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
    getPersonnelPermitTableData: builder.query({
      query: ({ id, sortBy = 'id', sortDir = 'desc' }) => ({
        url: `/v1/personnel/permits/personnel/${id}?&sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    getPersonnelPermitById: builder.query({
      query: ({ id }) => ({
        url: `/v1/personnel/permits/${id}`,
      }),
    }),
    createOrUpdatePersonnelPermit: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/personnel/permits/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
    getPersonnelServiceDateTableData: builder.query({
      query: ({ id, sortBy = 'id', sortDir = 'desc' }) => ({
        url: `/v1/personnel/service-dates/personnel/${id}?&sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    getPersonnelServiceDateById: builder.query({
      query: ({ id }) => ({
        url: `/v1/personnel/service-dates/${id}`,
      }),
    }),
    createOrUpdatePersonnelServiceDate: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/personnel/service-dates/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
  }),
});

export const {
  useGetPersonnelDataMutation,
  useCreateOrUpdatePersonnelDataMutation,
  useLazyGetPersonnelIdentificationTableDataQuery,
  useLazyGetPersonnelIdentificationByIdQuery,
  useCreateOrUpdatePersonnelIdentificationMutation,
  useLazyGetPersonnelCertificationTableDataQuery,
  useLazyGetPersonnelCertificationByIdQuery,
  useCreateOrUpdatePersonnelCertificationMutation,
  useLazyGetPersonnelScreeningTableDataQuery,
  useLazyGetPersonnelScreeningByIdQuery,
  useCreateOrUpdatePersonnelScreeningMutation,
  useLazyGetPersonnelPermitTableDataQuery,
  useLazyGetPersonnelPermitByIdQuery,
  useCreateOrUpdatePersonnelPermitMutation,
  useLazyGetPersonnelServiceDateTableDataQuery,
  useLazyGetPersonnelServiceDateByIdQuery,
  useCreateOrUpdatePersonnelServiceDateMutation,
} = personnelApi;
